import { default as currencyLib } from "currency.js";

export function currency(input, stripNonSignificant = false) {
    let value = currencyLib(input).format();
    if (stripNonSignificant) {
        return value.replace(/\.[0]+/, "");
    }
    return value;
}

export const snakeCase = (string, glue = "_") => {
    return string
        .replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map((word) => word.toLowerCase())
        .join(glue);
};

export const kebabCase = (string) => {
    return snakeCase(string, "-");
};

export function rescue(callback) {
    try {
        callback();
    } catch (error) {}
}

// helper functions for Raffle
export function ordinal_suffix_of(i) {
    let j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

export function formatToDaysLeft(date) {
    try {
        const targetDate = new Date(date);
        const today = new Date();

        // Reset time part of the dates to ensure only the date part is compared
        targetDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        // Calculate the difference in time
        const timeDifference = targetDate - today;

        // Convert time difference to days
        const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

        return daysLeft;
    } catch (e) {
        console.error("Invalid date format:", e);
        return null;
    }
}

export function formatDateToDDMMYYYY(date) {
    try {
        const targetDate = new Date(date);
        const day = String(targetDate.getDate()).padStart(2, "0");
        const month = String(targetDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = targetDate.getFullYear();

        return `${day}/${month}/${year}`;
    } catch (e) {
        console.error("Invalid date format:", e);
        return null;
    }
}

export function formatDateToMMDDYYYY(date) {
    try {
        const targetDate = new Date(date);
        const day = String(targetDate.getDate()).padStart(2, "0");
        const month = String(targetDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = targetDate.getFullYear();

        return `${month}/${day}/${year}`;
    } catch (e) {
        console.error("Invalid date format:", e);
        return null;
    }
}

export function formatDateWithOrdinalSuffix(date) {
    const targetDate = new Date(date);
    const day = targetDate.getDate();
    const month = targetDate.toLocaleString("default", { month: "long" });
    const year = targetDate.getFullYear();

    const ordinalSuffix = (day) => {
        if (day > 3 && day < 21) return `${day}th`;
        switch (day % 10) {
            case 1:
                return `${day}st`;
            case 2:
                return `${day}nd`;
            case 3:
                return `${day}rd`;
            default:
                return `${day}th`;
        }
    };

    return `${ordinalSuffix(day)} ${month} ${year}`;
}

export function getInitial(xName) {
    // check if is not empty
    if (xName) {
        // get the first letter of the name
        return xName[0].toUpperCase() + ".";
    } else {
        return null;
    }
}

export function formatToReadableDate(date, type) {
    try {
        const d = new Date(date);

        const day = d.getDate();
        const month = d.toLocaleString("default", { month: "long" });
        // const year = d.getFullYear()
        const time = formatAMPM(d);

        const weekday = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];

        let dayInWeek = weekday[d.getDay()];

        if (type == 1) {
            return `${dayInWeek} the ${nthNumber(day)} of ${month} at ${time}`;
        } else {
            return `${nthNumber(day)} of ${month} at ${time}`;
        }
    } catch (e) {
        return date;
    }
}

function formatAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + ampm;
}

function nthNumber(number) {
    const ordinal =
        number > 0
            ? ["th", "st", "nd", "rd"][
                  (number > 3 && number < 21) || number % 10 > 3
                      ? 0
                      : number % 10
              ]
            : "";

    return `${number}${ordinal}`;
}
